import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findParentNode } from '@atlaskit/editor-prosemirror/utils';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { getSupportedNodesForAIModal } from '../../utils/ai-button';
import { aiButtonPluginKey } from './ai-button-plugin-key';
export var createAIButtonPlugin = function createAIButtonPlugin(options) {
  var dispatch = options.dispatch;
  return new SafePlugin({
    key: aiButtonPluginKey,
    state: {
      init: function init(_, state) {
        return {
          isSelectionValidForAIExperience: true
        };
      },
      apply: function apply(tr, _pluginState, _oldEditorState, newEditorState) {
        if (tr.selectionSet) {
          var selection = tr.selection;
          var $from = selection.$from;
          var parent = $from.parent;
          var _newEditorState$schem = newEditorState.schema.nodes,
            codeBlock = _newEditorState$schem.codeBlock,
            tableHeader = _newEditorState$schem.tableHeader,
            tableCell = _newEditorState$schem.tableCell,
            tabeRow = _newEditorState$schem.tabeRow,
            table = _newEditorState$schem.table;
          var isNodeSelection = selection instanceof NodeSelection;
          var isSelectionInCodeBlock = parent.type === codeBlock;
          var isCellSelection = [tableHeader, tableCell, tabeRow, table].includes(parent.type);

          // AI button is always disabled for Node selection.
          // AI button is always disabled for Cell selection.
          // AI button is always disabled for selection in code block.
          // For all other selection and empty selections AI button is enabled.
          var isSelectionValidForAIExperience = true;
          if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) {
            isSelectionValidForAIExperience = false;
          }
          var newPluginState = {
            isSelectionValidForAIExperience: isSelectionValidForAIExperience
          };

          //TODO: AI Button experiment cleanup - platform_editor_ai_ai_button_block_elements
          var getParentSupportedForAIButton = function getParentSupportedForAIButton() {
            var supportedNodesForAI = getSupportedNodesForAIModal(newEditorState);
            if (isNodeSelection) {
              return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
            } else {
              var parentNodeFindResult = findParentNode(function (node) {
                return supportedNodesForAI.has(node.type);
              })(selection);
              return parentNodeFindResult === null || parentNodeFindResult === void 0 ? void 0 : parentNodeFindResult.node;
            }
          };
          var parentSupportedForAIButton = getParentSupportedForAIButton();
          var from = selection.from,
            to = selection.to;
          if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
            if (editorExperiment('platform_editor_ai_ai_button_block_elements', 'test', {
              exposure: true
            })) {
              var isTextSelection = selection instanceof TextSelection;
              var _isSelectionValidForAIExperience = !isSelectionInCodeBlock && (isTextSelection || !!parentSupportedForAIButton);
              var triggeredFor = parentSupportedForAIButton === null || parentSupportedForAIButton === void 0 ? void 0 : parentSupportedForAIButton.type;
              newPluginState = {
                isSelectionValidForAIExperience: _isSelectionValidForAIExperience,
                triggeredFor: triggeredFor
              };
            }
          }

          // We need to dispatch state change
          // As we use WithPluginState to enable/disable AI button.
          dispatch(aiButtonPluginKey, newPluginState);
          return newPluginState;
        }
        return _pluginState;
      }
    }
  });
};